let isMaintenanceMode = false;

export const setMaintenanceMode = (value: boolean): void => {
  isMaintenanceMode = value;
};

export const getMaintenanceMode = (): boolean => isMaintenanceMode;

const originalFetch = window.fetch.bind(window);

window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  if (isMaintenanceMode) {
    return new Response(JSON.stringify({ message: 'Service is under maintenance' }), {
      status: 503,
      headers: { 'Content-Type': 'application/json' },
    });
  }
  return originalFetch(input, init);
};
